import { axiosGET, axiosPOST } from '../../Helpers/TypeAxios'
import { urlParseParams } from "../../Helpers/helpFunction";

const routerRoot = 'a';

export default class A {
  getOverview(data?: any) {
    const stringUrl = urlParseParams(data);
    return axiosGET(`/${routerRoot}/overview?${stringUrl}`, {})
  }
  getIcbOverview(data?: any) {
    const stringUrl = urlParseParams(data);
    return axiosGET(`/${routerRoot}/icb/overview?${stringUrl}`, {})
  }
}
